import { render, staticRenderFns } from "./TableTabs.vue?vue&type=template&id=0a09cd65&scoped=true&lang=pug"
import script from "./TableTabs.vue?vue&type=script&lang=ts"
export * from "./TableTabs.vue?vue&type=script&lang=ts"
import style0 from "./TableTabs.vue?vue&type=style&index=0&id=0a09cd65&prod&lang=sass&scoped=true"
import style1 from "./TableTabs.vue?vue&type=style&index=1&id=0a09cd65&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a09cd65",
  null
  
)

/* custom blocks */
import block0 from "./TableTabs.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FTasks%2FTable%2FTableTabs.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports